import React from 'react'

const Header = () => {
    return ( 
        <h1 style={{color: 'gold', textAlign: 'center'}}>
            Minhas Tarefas
        </h1>
     );
}
 
export default Header;